import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import Drip from 'drip';
export default {
  name: 'DailyCouponNew',
  props: {
    dailyCouponData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      cardTitle: '',
      cardSubTitle: ''
    };
  },
  computed: {
    performanceId: function performanceId() {
      var _this$dailyCouponData, _this$dailyCouponData2;
      return (_this$dailyCouponData = this.dailyCouponData) === null || _this$dailyCouponData === void 0 ? void 0 : (_this$dailyCouponData2 = _this$dailyCouponData.dailyCouponGroupProjects) === null || _this$dailyCouponData2 === void 0 ? void 0 : _this$dailyCouponData2.map(function (item) {
        return item.projectId;
      }).slice(0, 2).join(',');
    }
  },
  watch: {
    dailyCouponData: 'initData'
  },
  mounted: function mounted() {
    this.initData();
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_e4gfkopp_mv',
      performance_id: this.performanceId,
      marketing_type: 1 // 1.天天神券 2.捡漏拍
    });
  },

  methods: {
    initData: function initData() {
      var _this$dailyCouponData3, _this$dailyCouponData4;
      // 判断是否是周四
      var isThursday = dayjs().day() === 4;
      this.cardTitle = isThursday ? '省钱星期四' : (_this$dailyCouponData3 = this.dailyCouponData) === null || _this$dailyCouponData3 === void 0 ? void 0 : _this$dailyCouponData3.moduleTitle;
      this.cardSubTitle = isThursday ? '周周4折起' : (_this$dailyCouponData4 = this.dailyCouponData) === null || _this$dailyCouponData4 === void 0 ? void 0 : _this$dailyCouponData4.moduleSubTitle;
    },
    handleClickCard: function handleClickCard() {
      var _this$dailyCouponData5;
      var performanceId = this.performanceId;
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_e4gfkopp_mc',
        performance_id: performanceId,
        needTag: true,
        marketing_type: 1 // 1.天天神券 2.捡漏拍
      });

      var url = (_this$dailyCouponData5 = this.dailyCouponData) === null || _this$dailyCouponData5 === void 0 ? void 0 : _this$dailyCouponData5.jumpUrl;
      Drip.redirect(url);
    }
  }
};